/**
 * @file Generated by js-routes 2.4.0. Based on Rails 8.1.3 routes of Medevrika::Application.
 * @version aef2b29364d6dc3eed320d6042d5ff7b4b87d8350bf935cc1504296e084b07a7
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line @typescript-eslint/no-unused-expressions
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Router = (() => {
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class Router {
        constructor(config = {}) {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "__options__",
                serializer: this.default_serializer.bind(this),
                deprecated_false_parameter_behavior: false,
                deprecated_nil_query_parameter_behavior: false,
                include_undefined_query_parameters: true,
            };
            this.configure(config);
        }
        configure(new_config) {
            var _a;
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            (_a = new_config.serializer) !== null && _a !== void 0 ? _a : (new_config.serializer = this.default_serializer.bind(this));
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        __route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        default_serializer(value, prefix, array_element = false) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("URL parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                // Rails serializes an empty array nested inside another array as a nil
                // query value, while an empty object contributes no query parameter.
                if (value.length === 0) {
                    return array_element
                        ? this.default_serializer(null, prefix + "[]")
                        : "";
                }
                for (const element of value) {
                    const subvalue = this.default_serializer(element, prefix + "[]", true);
                    // Skip empty object results so arrays do not produce leading,
                    // trailing, or doubled "&" separators.
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!this.hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (!this.configuration.include_undefined_query_parameters &&
                        prop === undefined) {
                        continue;
                    }
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                const key = encodeURIComponent(prefix);
                result.push(this.is_not_nullable(value) ||
                    this.configuration.deprecated_nil_query_parameter_behavior
                    ? key + "=" + encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : key);
            }
            return result.join("&");
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) && !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (this.configuration.deprecated_false_parameter_behavior &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!this.hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!this.hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!this.hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !this.hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        hasProp(value, key) {
            return Object.prototype.hasOwnProperty.call(value, key);
        }
    }
    return Router;
})();
;
const __jsr = (() => {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    ;
    const Modules = {
        references: {
            CJS: {
                define(routes) {
                    if (module) {
                        // Some javascript processors (like vite/rolldown)
                        // warn on using module dot exports in an ESM module.
                        // This just obfuscates that assignment a little so
                        // users don't get a warning they can't fix.
                        const _mod = module;
                        _mod.exports = routes;
                    }
                },
                isSupported() {
                    return typeof module === "object";
                },
            },
            AMD: {
                define(routes) {
                    if (define) {
                        define([], function () {
                            return routes;
                        });
                    }
                },
                isSupported() {
                    return typeof define === "function" && !!define.amd;
                },
            },
            UMD: {
                define(routes) {
                    if (Modules.references.AMD.isSupported()) {
                        Modules.references.AMD.define(routes);
                    }
                    else {
                        if (Modules.references.CJS.isSupported()) {
                            try {
                                Modules.references.CJS.define(routes);
                            }
                            catch (error) {
                                if (error.name !== "TypeError")
                                    throw error;
                            }
                        }
                    }
                },
                isSupported() {
                    return (Modules.references.AMD.isSupported() ||
                        Modules.references.CJS.isSupported());
                },
            },
            ESM: {
                define() {
                    // Module can only be defined using ruby code generation
                },
                isSupported() {
                    // Its impossible to check if "export" keyword is supported
                    return true;
                },
            },
            NIL: {
                define() {
                    // Defined using RubyVariables . WRAPPER
                },
                isSupported() {
                    return true;
                },
            },
            DTS: {
                // Acts the same as ESM
                define(routes) {
                    Modules.references.ESM.define(routes);
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
            PKG: {
                // Acts the same as ESM
                define() {
                    Modules.references.ESM.define(new Router());
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
        },
        is_module_supported(name) {
            return this.references[name].isSupported();
        },
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        },
        define_module(name, module) {
            this.ensure_module_supported(name);
            this.references[name].define(module);
            return module;
        },
    };
    const router = new Router({
        prefix: "",
        default_url_options: {},
        special_options_key: "_options",
        serializer: (_a = null) !== null && _a !== void 0 ? _a : undefined,
        deprecated_false_parameter_behavior: false,
        deprecated_nil_query_parameter_behavior: false,
        include_undefined_query_parameters: true,
    });
    const __route = router.__route.bind(router);
    return Modules.define_module("ESM", {
        __route,
        configure: router.configure.bind(router),
        config: router.config.bind(router),
        serialize: router.serialize.bind(router),
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

export const __route = __jsr.__route;

/**
 * Generates rails route to
 * /invitations/:id/activate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activate_invitation_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ai_chats/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_chat_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ai_chats"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ai_chats/:ai_chat_id/rag_traces/:id(.:format)
 * @param {any} ai_chat_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_chat_rag_trace_path = /*#__PURE__*/ __route({"ai_chat_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ai_chats"],[2,[7,"/"],[2,[3,"ai_chat_id"],[2,[7,"/"],[2,[6,"rag_traces"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ai_chats/:ai_chat_id/rag_traces(.:format)
 * @param {any} ai_chat_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_chat_rag_traces_path = /*#__PURE__*/ __route({"ai_chat_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ai_chats"],[2,[7,"/"],[2,[3,"ai_chat_id"],[2,[7,"/"],[2,[6,"rag_traces"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ai_chats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_chats_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"ai_chats"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/internal/ontologies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_internal_ontologies_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"ontologies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/ontologies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_internal_ontology_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"ontologies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /terms/:id/:term/article(.:format)
 * @param {any} id
 * @param {any} term
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const article_term_path = /*#__PURE__*/ __route({"id":{"r":true},"term":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"terms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"term"],[2,[7,"/"],[2,[6,"article"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authenticated_root_path = /*#__PURE__*/ __route({}, [7,"/"]);

/**
 * Generates rails route to
 * /terms/by_prefix/:prefix(.:format)
 * @param {any} prefix
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const by_prefix_terms_path = /*#__PURE__*/ __route({"prefix":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"terms"],[2,[7,"/"],[2,[6,"by_prefix"],[2,[7,"/"],[2,[3,"prefix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tn_drugs/by_prefix/:prefix(.:format)
 * @param {any} prefix
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const by_prefix_tn_drugs_path = /*#__PURE__*/ __route({"prefix":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tn_drugs"],[2,[7,"/"],[2,[6,"by_prefix"],[2,[7,"/"],[2,[3,"prefix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /inn_drugs/:title(.:format)
 * @param {any} title
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const by_title_inn_drugs_path = /*#__PURE__*/ __route({"title":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"inn_drugs"],[2,[7,"/"],[2,[3,"title"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_user_registration_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/rubricator/categories/:node_uid(.:format)
 * @param {any} organization_id
 * @param {any} node_uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const category_organization_rubricator_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"node_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"rubricator"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"node_uid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chats/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chat_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"chats"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /chats/:chat_id/rag_traces/:id(.:format)
 * @param {any} chat_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chat_rag_trace_path = /*#__PURE__*/ __route({"chat_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"chats"],[2,[7,"/"],[2,[3,"chat_id"],[2,[7,"/"],[2,[6,"rag_traces"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chats/:chat_id/rag_traces(.:format)
 * @param {any} chat_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chat_rag_traces_path = /*#__PURE__*/ __route({"chat_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"chats"],[2,[7,"/"],[2,[3,"chat_id"],[2,[7,"/"],[2,[6,"rag_traces"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /collections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const collection_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"collections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /collections/:collection_hfurl(.:format)
 * @param {any} collection_hfurl
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const collection_hfurl_path = /*#__PURE__*/ __route({"collection_hfurl":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"collections"],[2,[7,"/"],[2,[3,"collection_hfurl"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /collections/:collection_hfurl/:item_hfurl(.:format)
 * @param {any} collection_hfurl
 * @param {any} item_hfurl
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const collection_publication_path = /*#__PURE__*/ __route({"collection_hfurl":{"r":true},"item_hfurl":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"collections"],[2,[7,"/"],[2,[3,"collection_hfurl"],[2,[7,"/"],[2,[3,"item_hfurl"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /collections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const collections_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"collections"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ontologies/:id/commit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const commit_ontology_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ontologies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"commit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /content/:content_type/:content_id(.:format)
 * @param {any} content_type
 * @param {any} content_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const content_path = /*#__PURE__*/ __route({"content_type":{"r":true},"content_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"content"],[2,[7,"/"],[2,[3,"content_type"],[2,[7,"/"],[2,[3,"content_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /content/:content_type/:content_id/attachments/:key(.:format)
 * @param {any} content_type
 * @param {any} content_id
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const content_attachment_path = /*#__PURE__*/ __route({"content_type":{"r":true},"content_id":{"r":true},"key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"content"],[2,[7,"/"],[2,[3,"content_type"],[2,[7,"/"],[2,[3,"content_id"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[3,"key"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /content/:content_type/:content_id/bookmarks/:id(.:format)
 * @param {any} content_type
 * @param {any} content_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const content_bookmark_path = /*#__PURE__*/ __route({"content_type":{"r":true},"content_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"content"],[2,[7,"/"],[2,[3,"content_type"],[2,[7,"/"],[2,[3,"content_id"],[2,[7,"/"],[2,[6,"bookmarks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /content/:content_type/:content_id/bookmarks(.:format)
 * @param {any} content_type
 * @param {any} content_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const content_bookmarks_path = /*#__PURE__*/ __route({"content_type":{"r":true},"content_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"content"],[2,[7,"/"],[2,[3,"content_type"],[2,[7,"/"],[2,[3,"content_id"],[2,[7,"/"],[2,[6,"bookmarks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /content_chunks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const content_chunk_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"content_chunks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /content_chunks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const content_chunks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"content_chunks"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /content/*hfurl_tail(.:format)
 * @param {any} hfurl_tail
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const content_hfurl_path = /*#__PURE__*/ __route({"hfurl_tail":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"content"],[2,[7,"/"],[2,[5,[3,"hfurl_tail"]],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /content_notes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const content_note_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"content_notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /content_notes/:content_note_id/discussion_thread(.:format)
 * @param {any} content_note_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const content_note_discussion_thread_path = /*#__PURE__*/ __route({"content_note_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"content_notes"],[2,[7,"/"],[2,[3,"content_note_id"],[2,[7,"/"],[2,[6,"discussion_thread"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /content_notes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const content_notes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"content_notes"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /content/:content_type/:content_id/part/:part_id(.:format)
 * @param {any} content_type
 * @param {any} content_id
 * @param {any} part_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const content_part_path = /*#__PURE__*/ __route({"content_type":{"r":true},"content_id":{"r":true},"part_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"content"],[2,[7,"/"],[2,[3,"content_type"],[2,[7,"/"],[2,[3,"content_id"],[2,[7,"/"],[2,[6,"part"],[2,[7,"/"],[2,[3,"part_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:entity_type/:entity_id/:relation_slug(.:format)
 * @param {any} entity_type
 * @param {any} entity_id
 * @param {any} relation_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const content_relation_alias_path = /*#__PURE__*/ __route({"entity_type":{"r":true},"entity_id":{"r":true},"relation_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"entity_type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"relation_slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cookies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cookies_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"cookies"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /invitations/:id/deactivate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deactivate_invitation_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"deactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_user_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /content_diffs/:content_type/:new_id/to/:old_id(.:format)
 * @param {any} content_type
 * @param {any} new_id
 * @param {any} old_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const diff_content_diffs_path = /*#__PURE__*/ __route({"content_type":{"r":true},"new_id":{"r":true},"old_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"content_diffs"],[2,[7,"/"],[2,[3,"content_type"],[2,[7,"/"],[2,[3,"new_id"],[2,[7,"/"],[2,[6,"to"],[2,[7,"/"],[2,[3,"old_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /content/:content_type/:content_id/discussion_thread(.:format)
 * @param {any} content_type
 * @param {any} content_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discussion_thread_path = /*#__PURE__*/ __route({"content_type":{"r":true},"content_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"content"],[2,[7,"/"],[2,[3,"content_type"],[2,[7,"/"],[2,[3,"content_id"],[2,[7,"/"],[2,[6,"discussion_thread"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /discussion_threads/:discussion_thread_id/blocks/:id(.:format)
 * @param {any} discussion_thread_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discussion_thread_block_path = /*#__PURE__*/ __route({"discussion_thread_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discussion_threads"],[2,[7,"/"],[2,[3,"discussion_thread_id"],[2,[7,"/"],[2,[6,"blocks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /discussion_threads/:discussion_thread_id/blocks(.:format)
 * @param {any} discussion_thread_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discussion_thread_blocks_path = /*#__PURE__*/ __route({"discussion_thread_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discussion_threads"],[2,[7,"/"],[2,[3,"discussion_thread_id"],[2,[7,"/"],[2,[6,"blocks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /discussion_threads/:discussion_thread_id/comments(.:format)
 * @param {any} discussion_thread_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discussion_thread_comments_path = /*#__PURE__*/ __route({"discussion_thread_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discussion_threads"],[2,[7,"/"],[2,[3,"discussion_thread_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /collections/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_collection_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"collections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /content_notes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_content_note_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"content_notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ontologies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_ontology_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ontologies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ontologies/:ontology_id/entries/:id/edit(.:format)
 * @param {any} ontology_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_ontology_entry_path = /*#__PURE__*/ __route({"ontology_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ontologies"],[2,[7,"/"],[2,[3,"ontology_id"],[2,[7,"/"],[2,[6,"entries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /profiles/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_profile_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"profiles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /publications/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_publication_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"publications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /terms/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_term_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"terms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tn_drugs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_tn_drug_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tn_drugs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_password_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_registration_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /errors/404(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const errors_404_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"errors"],[2,[7,"/"],[2,[6,"404"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /errors/500(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const errors_500_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"errors"],[2,[7,"/"],[2,[6,"500"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /publications/:id/export_docx(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_docx_publication_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"publications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export_docx"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /publications/external_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_search_publications_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"publications"],[2,[7,"/"],[2,[6,"external_search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /feed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feed_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"feed"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /good_job
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_path = /*#__PURE__*/ __route({}, [2,[7,"/"],[6,"good_job"]]);

/**
 * Generates rails route to
 * /good_job/batches/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_batch_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"batches"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /good_job/batches(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_batches_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"batches"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /good_job/cleaner(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_cleaner_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"cleaner"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /good_job/cron_entries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_cron_entries_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"cron_entries"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /good_job/cron_entries/:cron_key(.:format)
 * @param {any} cron_key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_cron_entry_path = /*#__PURE__*/ __route({"cron_key":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"cron_entries"],[2,[7,"/"],[2,[3,"cron_key"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /good_job/cron_entries/:cron_key/disable(.:format)
 * @param {any} cron_key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_disable_cron_entry_path = /*#__PURE__*/ __route({"cron_key":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"cron_entries"],[2,[7,"/"],[2,[3,"cron_key"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/jobs/:id/discard(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_discard_job_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"discard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/cron_entries/:cron_key/enable(.:format)
 * @param {any} cron_key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_enable_cron_entry_path = /*#__PURE__*/ __route({"cron_key":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"cron_entries"],[2,[7,"/"],[2,[3,"cron_key"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/cron_entries/:cron_key/enqueue(.:format)
 * @param {any} cron_key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_enqueue_cron_entry_path = /*#__PURE__*/ __route({"cron_key":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"cron_entries"],[2,[7,"/"],[2,[3,"cron_key"],[2,[7,"/"],[2,[6,"enqueue"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/jobs/:id/force_discard(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_force_discard_job_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"force_discard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/frontend/modules/:version/:id(.:format)
 * @param {any} version
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_frontend_module_path = /*#__PURE__*/ __route({"version":{"r":true,"d":"4-19-0"},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"frontend"],[2,[7,"/"],[2,[6,"modules"],[2,[7,"/"],[2,[3,"version"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/frontend/static/:version/:id(.:format)
 * @param {any} version
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_frontend_static_path = /*#__PURE__*/ __route({"version":{"r":true,"d":"4-19-0"},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"frontend"],[2,[7,"/"],[2,[6,"static"],[2,[7,"/"],[2,[3,"version"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/jobs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_job_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /good_job/jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_jobs_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /good_job/jobs/mass_update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_mass_update_jobs_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"mass_update"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /good_job/jobs/metrics/job_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_metrics_job_status_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"metrics"],[2,[7,"/"],[2,[6,"job_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/jobs/metrics/primary_nav(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_metrics_primary_nav_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"metrics"],[2,[7,"/"],[2,[6,"primary_nav"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/pauses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_pauses_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"pauses"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /good_job/performance/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_performance_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"performance"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /good_job/performance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_performance_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"performance"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /good_job/processes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_processes_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"processes"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /good_job/jobs/:id/reschedule(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_reschedule_job_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reschedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/batches/:id/retry(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_retry_batch_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"batches"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/jobs/:id/retry(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_retry_job_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_root_path = /*#__PURE__*/ __route({}, [2,[2,[7,"/"],[6,"good_job"]],[7,"/"]]);

/**
 * Generates rails route to
 * /inn_drugs/:id/:title(.:format)
 * @param {any} id
 * @param {any} title
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hfurl_inn_drug_path = /*#__PURE__*/ __route({"id":{"r":true},"title":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"inn_drugs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"title"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /*hfurl(.:format)
 * @param {any} hfurl
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hfurl_publication_path = /*#__PURE__*/ __route({"hfurl":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"hfurl"]],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /tn_drugs/:id/:title(.:format)
 * @param {any} id
 * @param {any} title
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hfurl_tn_drug_path = /*#__PURE__*/ __route({"id":{"r":true},"title":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tn_drugs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"title"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /content_chunks/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_content_chunks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"content_chunks"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /terms/index_by_prefix/:prefix(.:format)
 * @param {any} prefix
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const index_by_prefix_terms_path = /*#__PURE__*/ __route({"prefix":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"terms"],[2,[7,"/"],[2,[6,"index_by_prefix"],[2,[7,"/"],[2,[3,"prefix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tn_drugs/index_by_prefix/:prefix(.:format)
 * @param {any} prefix
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const index_by_prefix_tn_drugs_path = /*#__PURE__*/ __route({"prefix":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tn_drugs"],[2,[7,"/"],[2,[6,"index_by_prefix"],[2,[7,"/"],[2,[3,"prefix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /inn_drugs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inn_drug_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"inn_drugs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /publications/inn_drug_instructions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inn_drug_instructions_publications_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"publications"],[2,[7,"/"],[2,[6,"inn_drug_instructions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /invitations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invitation_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /invitations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invitations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"invitations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /legal/terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legal_terms_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"legal"],[2,[7,"/"],[2,[6,"terms"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ontologies/:ontology_id/entries/:id/move/:anchor_type(/:anchor_id)(.:format)
 * @param {any} ontology_id
 * @param {any} id
 * @param {any} anchor_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const move_ontology_entry_path = /*#__PURE__*/ __route({"ontology_id":{"r":true},"id":{"r":true},"anchor_type":{"r":true},"anchor_id":{},"format":{}}, [2,[7,"/"],[2,[6,"ontologies"],[2,[7,"/"],[2,[3,"ontology_id"],[2,[7,"/"],[2,[6,"entries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"move"],[2,[7,"/"],[2,[3,"anchor_type"],[2,[1,[2,[7,"/"],[3,"anchor_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ontologies/:ontology_id/entries/info(.:format)
 * @param {any} ontology_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const multiple_ontology_entries_path = /*#__PURE__*/ __route({"ontology_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ontologies"],[2,[7,"/"],[2,[3,"ontology_id"],[2,[7,"/"],[2,[6,"entries"],[2,[7,"/"],[2,[6,"info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /my_summaries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_summaries_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"my_summaries"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /chats/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_chat_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"chats"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /collections/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_collection_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"collections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /content_chunks/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_content_chunk_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"content_chunks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /content_diffs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_content_diff_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"content_diffs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /content_notes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_content_note_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"content_notes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ontologies/:ontology_id/entries/new(.:format)
 * @param {any} ontology_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ontology_entry_path = /*#__PURE__*/ __route({"ontology_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ontologies"],[2,[7,"/"],[2,[3,"ontology_id"],[2,[7,"/"],[2,[6,"entries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /publications/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_publication_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"publications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /searches/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_search_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"searches"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /terms/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_term_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"terms"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tn_drugs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_tn_drug_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"tn_drugs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/confirmation/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_confirmation_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_password_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_registration_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/unlock/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_unlock_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unlock"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ontologies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ontologies_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"ontologies"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ontologies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ontology_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ontologies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ontologies/:ontology_id/entries(.:format)
 * @param {any} ontology_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ontology_entries_path = /*#__PURE__*/ __route({"ontology_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ontologies"],[2,[7,"/"],[2,[3,"ontology_id"],[2,[7,"/"],[2,[6,"entries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ontologies/:ontology_id/entries/:id(.:format)
 * @param {any} ontology_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ontology_entry_path = /*#__PURE__*/ __route({"ontology_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ontologies"],[2,[7,"/"],[2,[3,"ontology_id"],[2,[7,"/"],[2,[6,"entries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /content_diffs/options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const options_content_diffs_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"content_diffs"],[2,[7,"/"],[2,[6,"options"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organization_category_assignments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_category_assignments_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"organization_category_assignments"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/departments/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_department_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"departments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/departments/:department_id/memberships/:id(.:format)
 * @param {any} organization_id
 * @param {any} department_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_department_membership_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"department_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"departments"],[2,[7,"/"],[2,[3,"department_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/departments/:department_id/memberships(.:format)
 * @param {any} organization_id
 * @param {any} department_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_department_memberships_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"department_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"departments"],[2,[7,"/"],[2,[3,"department_id"],[2,[7,"/"],[2,[6,"memberships"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/departments(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_departments_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"departments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/memberships/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_membership_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/memberships(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_memberships_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"memberships"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/permissions(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_permissions_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/rubricator(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_rubricator_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"rubricator"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/rubricator/category_restrictions/:node_uid(.:format)
 * @param {any} organization_id
 * @param {any} node_uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_rubricator_category_restriction_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"node_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"rubricator"],[2,[7,"/"],[2,[6,"category_restrictions"],[2,[7,"/"],[2,[3,"node_uid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/users(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_users_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /outer_gate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const outer_gate_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"outer_gate"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /content_chunks/:id/part/:part_id(.:format)
 * @param {any} id
 * @param {any} part_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const part_content_chunk_path = /*#__PURE__*/ __route({"id":{"r":true},"part_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"content_chunks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"part"],[2,[7,"/"],[2,[3,"part_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /privacy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const privacy_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"privacy"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /profiles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profile_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /publications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publication_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"publications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /publications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publications_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"publications"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ai_chats/:id/rag_debug(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rag_debug_ai_chat_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ai_chats"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rag_debug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_path = /*#__PURE__*/ __route({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_path = /*#__PURE__*/ __route({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_path = /*#__PURE__*/ __route({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_path = /*#__PURE__*/ __route({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_path = /*#__PURE__*/ __route({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reaction(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reaction_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reaction"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ontologies/:id/reset(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_ontology_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ontologies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = /*#__PURE__*/ __route({}, [7,"/"]);

/**
 * Generates rails route to
 * /terms/search/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_new_terms_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"terms"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tn_drugs/search/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_new_tn_drugs_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"tn_drugs"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ontologies/:ontology_id/entries/search(.:format)
 * @param {any} ontology_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_ontology_entries_path = /*#__PURE__*/ __route({"ontology_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ontologies"],[2,[7,"/"],[2,[3,"ontology_id"],[2,[7,"/"],[2,[6,"entries"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /terms/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_terms_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"terms"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tn_drugs/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_tn_drugs_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"tn_drugs"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /searches(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searches_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"searches"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /chats/settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_chats_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"chats"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /subscription(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscription_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"subscription"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /discussion_threads/:discussion_thread_id/comments/:id/subtree(.:format)
 * @param {any} discussion_thread_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subtree_discussion_thread_comment_path = /*#__PURE__*/ __route({"discussion_thread_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discussion_threads"],[2,[7,"/"],[2,[3,"discussion_thread_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"subtree"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /content_diffs/:new_id/to/:old_id/summary(.:format)
 * @param {any} new_id
 * @param {any} old_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const summary_content_diffs_path = /*#__PURE__*/ __route({"new_id":{"r":true},"old_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"content_diffs"],[2,[7,"/"],[2,[3,"new_id"],[2,[7,"/"],[2,[6,"to"],[2,[7,"/"],[2,[3,"old_id"],[2,[7,"/"],[2,[6,"summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /terms/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const term_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"terms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terms_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"terms"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /content_notes/timeline(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timeline_content_notes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"content_notes"],[2,[7,"/"],[2,[6,"timeline"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tn_drugs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tn_drug_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tn_drugs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /publications/tn_drug_instructions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tn_drug_instructions_publications_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"publications"],[2,[7,"/"],[2,[6,"tn_drug_instructions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tn_drugs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tn_drugs_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"tn_drugs"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ontologies/:ontology_id/entries/tree(.:format)
 * @param {any} ontology_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tree_ontology_entries_path = /*#__PURE__*/ __route({"ontology_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ontologies"],[2,[7,"/"],[2,[3,"ontology_id"],[2,[7,"/"],[2,[6,"entries"],[2,[7,"/"],[2,[6,"tree"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_path = /*#__PURE__*/ __route({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_confirmation_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_password_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/permissions/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_permission_path = /*#__PURE__*/ __route({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"permissions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/permissions(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_permissions_path = /*#__PURE__*/ __route({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_registration_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/unlock(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_unlock_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unlock"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/me(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_me_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"me"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /welcome(/:invitation_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const welcome_path = /*#__PURE__*/ __route({"invitation_id":{},"format":{}}, [2,[7,"/"],[2,[6,"welcome"],[2,[1,[2,[7,"/"],[3,"invitation_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]);

